export default __webpack_public_path__ + "static/15_30-ae3a50c9c75fb0acff3f1864069b1399.png";